<template>
   <div class="outer">
      <!-- 裕禾,柴米油盐充值卡记录出库金额 -->
      <el-dialog width="35%" :close-on-click-modal="false" :title="outCardTitle" :visible="outCardVisable" v-if="outCardVisable"
         @close="closeOutCard">
         <el-form ref="outCardForm" :model="outCardForm" :rules="outCardRules" label-width="130px" style="width: 89%;">
            <el-form-item label="消费类型" prop="outType" required>
               <el-select style="width: 100%" v-model="outCardForm.outType" :disabled="outCardType === 'edit'" @change="outTypeChange" placeholder="请选择">
                  <el-option label="项目用" :value="1" :disabled="!isXiaos"></el-option>
                  <el-option label="部门用" :value="2"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="充值卡名称" prop="goodsCode" required>
               <el-select style="width: 100%" v-model="outCardForm.goodsCode" :disabled="outCardType === 'edit'" placeholder="请选择" @change="onGoodsChange">
                  <el-option v-for="(item,i) in cardList" :key="i" :label="item.goodsName" :value="item.goodsCode"></el-option>
               </el-select>
               <span v-if="outCardForm.inventoryNum">(剩余金额: {{ outCardForm.inventoryNum }})</span>
            </el-form-item>
            <el-form-item label="项目名称" prop="chanceId" v-if="outCardForm.outType === 1" required>
               <el-select style="width: 100%" filterable v-model="outCardForm.chanceId" placeholder="请选择" :disabled="outCardType === 'edit' && outboundPerission">
                  <el-option v-for="(item, i) in projectList" :key="i" :label="item.name" :value="item.code">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="消费人部门"  v-if="outCardForm.outType === 2" prop="departmentId" label-width="130px">
               <treeselect :disable-branch-nodes="true" disabled v-model="outCardForm.departmentId"
                  :options="deptOptions" :clearable="false" :default-expand-level="2" :normalizer="normalizer"
                  placeholder="请选择部门" @select="handleSelect"/>
            </el-form-item>
            <el-form-item label="消费人" v-if="outCardForm.outType === 2" prop="receiverUserId" label-width="130px">
               <el-select class="userSelect" disabled style="width: 100%" v-model="outCardForm.receiverUserId" placeholder="请选择"
                  :popper-append-to-body="false" clearable>
                  <el-option v-for="item in CeOptions" :key="item.id" :label="item.trueName" :value="item.id">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="消费金额" prop="goodsNum" v-if="outCardType == 'edit' && outboundPerission" required>
               <div class="flex-center">
                  <el-input style="width: 100%" type="number" v-model="outCardForm.goodsNum" :disabled="outCardType === 'edit' && !outboundPerission"
                     :placeholder="outboundPerission ? '请输入' : '仅出库管理员可填'"></el-input>
               </div>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
               <div class="flex-center">
                  <el-input style="width: 100%" type="textarea" :rows="4" v-model="outCardForm.remarks" :disabled="outCardType === 'edit' && outboundPerission"
                     :placeholder="outCardType === 'add' ? '请输入' : ''"></el-input>
               </div>
            </el-form-item>
         </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button type="primary" :loading="btnLoading" @click="submitOutCard">确 定</el-button>
         </span>
      </el-dialog>

      <div class="topSearch">
         <div>
            <el-form class="queryRow" :model="queryForm" v-if="$store.state.jxcSystemPermission.AdminRole()">
               <el-form-item label="消费人部门" prop="departmentId" label-width="130px">
                  <treeselect :disable-branch-nodes="true" v-model="queryForm.departmentId" style="width: 200px;"
                     :options="deptOptions" :clearable="false" :default-expand-level="2" :normalizer="normalizer"
                     placeholder="请选择部门" @select="onDepartSelect"/>
               </el-form-item>
               <el-form-item label="消费人" prop="receiverUserId" label-width="100px">
                  <el-select class="userSelect" style="width: 100%" v-model="queryForm.receiverUserId" placeholder="请选择"
                     :popper-append-to-body="false" clearable @clear="onSearch" @change="onSearch">
                     <el-option v-for="item in qCeOptions" :key="item.id" :label="item.trueName" :value="item.id">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-form>
         </div>

         <div>
            <el-button type="primary" icon="el-icon-edit-outline" @click="openDialog({},'add')">
               充值卡消费
            </el-button>
         </div>

      </div>

      <el-table v-loading="loading" border class="table" :row-style="{ height: '50px' }"
         style="width: 100%;height: 75vh;overflow: auto;" :data="tableData">
         <template slot="empty">
            <el-empty :image-size="150"></el-empty>
         </template>
         <el-table-column align="center" label="出库单号" prop="outNo">
         </el-table-column>
         <el-table-column align="center" label="消费类型" prop="outType">
            <template slot-scope="scope">
               {{ scope.row.outType ? (scope.row.outType == 1 ? '项目用' : '部门用') : (scope.row.chanceId ? '项目用' : '部门用') }}
            </template>
         </el-table-column>
         <el-table-column align="center" label="项目名称" prop="chanceName">
         </el-table-column>
         <el-table-column align="center" label="货物名称" prop="goodsName">
         </el-table-column>
         <el-table-column align="center" label="消费金额" prop="goodsNum">
            <template slot-scope="scope">
               <div v-if="scope.row.goodsNum">
                  {{ scope.row.goodsNum }}元
               </div>
               <el-tag type="info" v-else>
                  待定
               </el-tag>
            </template>
         </el-table-column>
         <el-table-column align="center" label="消费人" prop="receiverUserName">
         </el-table-column>
         <el-table-column align="center" label="消费人部门" prop="departmentName">
         </el-table-column>
         <el-table-column align="center" label="创建时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
         </el-table-column>
         <el-table-column align="center" label="备注" prop="remarks">
         </el-table-column>
         <el-table-column align="center" label="操作" prop="operate" v-if="outboundPerission">
            <template slot-scope="scope">
               <el-button type="text" icon="el-icon-edit-outline" size="mini" @click="openDialog(scope.row,'edit')">编辑</el-button>
            </template>
         </el-table-column>
      </el-table>

      <div class="pageination">
         <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
            :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
            background layout="sizes, prev, pager, next, jumper, ->, total">
         </el-pagination>
      </div>
   </div>
</template>
<script>
import { queryOutStoreList } from '@/api/goods/inventory.js';
import { getUserSelectByPage } from "@/api/plat/PlatStaff";
import { getProjects, getAllProject } from '@/api/work/WorkOrderList.js';
import { addOutStoreCard, updateOutStoreCard } from '@/api/goods/applyForm.js';
import { queryWarehouse } from '@/api/goods/inventory.js';
import { isSales } from "@/views/goods/permission.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
   data() {
      return {
         btnLoading: false, // 提交按钮是否禁用
         loading: false,
         isXiaos: isSales(), // 销售类角色（roleId 2、3）可选项目用/商机
         total: 0, // 总条数
         tableData: [], // 表格数据
         queryForm: {
            page: 1,
            limit: 10,
            flag: 2,
            receiverUserId: '', // 消费人
         }, // 出库单查询列表
         deptOptions: [], // 部门选项
         qCeOptions: [], // 查询消费人下拉数据
         CeOptions: [],  // 货物提供人下拉数据
         outCardForm: {
            chanceId: '', // 项目
            departmentCode: null, // 消费人部门
            outType: '', // 出库类型
            receiverUserId: '', // 消费人
            goodsNum: 0, // 出库数量
            remarks: '', // 备注
            goodsCode: '', // 充值卡编码
            inventoryNum: '', // 库存数量
         },
         outCardRules: {
            chanceId: [
               { required: true, message: '请选择项目' }
            ],
            outType: [
               { required: true, message: '请选择出库类型' }
            ],
            goodsCode: [
               { required: true, message: '请选择充值卡' }
            ],
            goodsNum: [
               { required: true, message: '请输入消费金额' }
            ],
         },  
         outboundPerission: this.$store.state.jxcSystemPermission.AdminRole(), // 申领单审批权限 , uid === 202 卢雅静
         outCardVisable: false, // 出库单弹窗显隐
         projectList: [], // 项目列表
         cardList:[], // 充值卡列表
         outCardTitle: '', // 出库单弹窗标题
         outCardType: '', // 出库单类型
      }
   },
   components: {
      Treeselect,
   },
   async created() {
      this.queryOutStoreList();
      let deptArr = await this.getDimTableDeptByIds([213, 214, 216]);
      this.deptOptions = deptArr.data.concat([]);
      this.getCardList();
      this.isXiaos ? this.getProjects() : this.getAllProject();
   },
   computed: {
   },
   methods: {
      async onDepartSelect(node) {
         this.queryForm.receiverUserId = '';
         
         let { data } = await getUserSelectByPage({
            condition: {
               departmentId: node.id,
            },
            limit: 9999,
            page: 1,
         });
         this.qCeOptions = data.records;
      },
      outTypeChange(){
         this.outCardForm.chanceId = '';
         this.$refs.outCardForm.clearValidate();
      },
      async openDialog(row,type){
         this.outCardType = type;
         let departmentId = sessionStorage.getItem('departmentId');
         if(type == 'add'){
            this.outCardTitle = '新增充值卡消费记录';
            this.outCardForm.outType = this.isXiaos ? '' : 2;
            this.handleSelect({id: departmentId});
            this.outCardForm.departmentId = departmentId;
            this.outCardForm.receiverUserId = sessionStorage.getItem('uid') * 1;
            this.outCardForm.goodsNum = 0;
         }else if(type == 'edit'){
            this.outCardTitle = '修改充值卡消费记录';
            this.outCardForm = {
               ...row,
               departmentId: row.departmentId,
               outType: (row.outType !== undefined && row.outType !== null && row.outType !== '') ? Number(row.outType) : (row.chanceId ? 1 : 2),
               goodsNum: row.goodsNum || '',
            };
            this.onGoodsChange(this.outCardForm.goodsCode);
            this.handleSelect({id: row.departmentId});

         }    
         this.outCardVisable = true;

      },
      onGoodsChange(e){
         let item = this.cardList.find(item => item.goodsCode == e);
         if(item){
            this.outCardForm.inventoryNum = item.goodsNum;
         }
      },
      submitOutCard(){
         this.$refs.outCardForm.validate(valid => {
            if (valid) {
               if(this.outCardForm.outType === 1){
                  delete this.outCardForm.departmentCode;
                  delete this.outCardForm.departmentName;
               }
               if(this.outCardType == 'add'){
                  this.loading = true;
                  this.btnLoading = true;
                  addOutStoreCard(this.outCardForm).then(res => {
                     this.btnLoading = false;
                     if (res.code === 200) {
                        this.$message({
                           message: '新增成功',
                           type: 'success',
                        })
                        this.loading = false;
                        this.outCardVisable = false;
                        this.closeOutCard();
                        this.queryForm.page = 1;
                        this.queryOutStoreList();
                     }
                  })
               }else if(this.outCardType == 'edit'){
                  if(this.outCardForm.goodsNum > this.outCardForm.inventoryNum){
                     this.$message({
                        message: '消费金额不能大于剩余金额',
                        type: 'error',
                     })
                     return;
                  }
                  this.loading = true;
                  this.btnLoading = true;
                  updateOutStoreCard(this.outCardForm).then(res => {
                     this.btnLoading = false;
                     if (res.code === 200) {
                        this.$message({
                           message: '修改成功',
                           type: 'success',
                        })
                        this.loading = false;
                        this.closeOutCard();
                        this.getCardList();
                        this.outCardVisable = false;
                        this.queryForm.page = 1;
                        this.queryOutStoreList();
                     }
                  })
               }
            }
         })
      },
      getProjects() {
         getProjects().then(res => {
               if (res.code === 200) {
                  this.projectList = res.data
               }
         })
      },
      getAllProject() {
         getAllProject().then(res => {
               if (res.code === 200) {
                  this.projectList = res.result
               }
         })
      },
      // 获取充值卡列表
      getCardList() {
         queryWarehouse({
            page: 1,
            limit: 9999,
            category: '行政',
            goodsName: '充值卡',
         }).then(res => {
            if (res.code === 200) {
               this.cardList = res.data;
            }
         })
      },
      queryOutStoreList() {
         this.loading = true;
         queryOutStoreList(this.queryForm).then(res => {
            if (res.code === 200) {
               this.tableData = res.data;
               this.total = res.count;
            }
            this.loading = false;
         })
      },
      // 当每页条数变化
      onSizeChange(e) {
         this.queryForm.page = 1;
         this.queryForm.limit = e;
         this.queryOutStoreList();
      },
      // 搜索
      onSearch() {
         this.queryForm.page = 1;
         this.queryOutStoreList();
      },
      // 当页码发生变化时
      onCurrentChange(e) {
         this.queryForm.page = e;
         this.queryOutStoreList();
      },
      closeOutCard() {
         this.outCardVisable = false;
         this.outCardForm = {
            chanceId: '', // 项目ID
            goodsName: '', // 货物名称
            outType: '', // 出库类型
            receiverUserId: '', // 消费人
            goodsNum: '', // 出库数量
            remarks: '', // 备注
            goodsCode: '', // 充值卡编码
            inventoryNum: '', // 库存数量
         };
         this.CeOptions = [];
         this.$refs.outCardForm.resetFields();
         this.$refs.outCardForm.clearValidate();
      },
      /** 转换部门数据结构 */
      normalizer(node) {
         if (node.children && !node.children.length) {
            delete node.children;
         }
         return {
            id: node.id,
            code: node.code,
            label: node.name,
            children: node.children,
         };
      },
      // 节点单击事件
      async handleSelect(node) {
         this.deptOptions.forEach(item => {
            item.children.forEach(child => {
               if(child.id == node.id){
                  this.outCardForm.departmentCode = child.code;
                  this.outCardForm.departmentName = child.name;
               }
            })
         });
         
         let { data } = await getUserSelectByPage({
            condition: {
               departmentId: node.id,
            },
            limit: 9999,
            page: 1,
         });
         this.CeOptions = data.records;
      },
      // 获取所有的项目列表
      getProjectList() {
         getAllProject().then(res => {
            if (res.code === 200) {
               this.projectList = res.data;
            }
         })
      },
   },
}
</script>
<style lang="scss" scoped>
.outer {

   .el-form-item {
      margin-right: 20px;
   }

   .pageination {
      display: flex;
      justify-content: flex-end;
      margin-top: 5px
   }

   .topSearch {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
   }

   .queryRow {
      display: flex;

      .queryName {
         width: 300px;
         margin-right: 10px;
      }

      .dataPicker {
         margin-right: 10px;
      }
   }

   .detailTable {
      ::v-deep .el-checkbox__input {
         &.is-checked {
            .el-checkbox__inner {
               background-color: #409EFF;
               border-color: #409EFF;
            }
         }
      }
   }

   .el-table {
      ::v-deep .warning-row {
         display: none;
      }
   }

   .table {

      ::v-deep .el-table__cell {
         >:empty::before {
            content: '--';
            color: gray;
         }
      }
   }
}
</style>
